/** Icons of the sign-in and account screens. Same set as the rest (outline, grid 24, stroke 1.7):
 *  kept in their own file so the main map stays readable; `Icon` merges both. */
export const ACCOUNT_PATHS = {
  mail: (
    <>
      <rect x="3.2" y="5.4" width="17.6" height="13.2" rx="1.6" />
      <path d="m3.6 6.4 8.4 6.4 8.4-6.4" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10.4" width="14" height="10" rx="1.6" />
      <path d="M8.2 10.4V7.6a3.8 3.8 0 0 1 7.6 0v2.8" />
    </>
  ),
  eye: (
    <>
      <path d="M2.6 12S6 5.8 12 5.8 21.4 12 21.4 12 18 18.2 12 18.2 2.6 12 2.6 12Z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  eyeOff: (
    <>
      <path d="M4 4l16 16" />
      <path d="M9.9 6.1A9.6 9.6 0 0 1 12 5.8c6 0 9.4 6.2 9.4 6.2a16 16 0 0 1-2.6 3.3M6.4 7.6A15.6 15.6 0 0 0 2.6 12S6 18.2 12 18.2a9 9 0 0 0 4.2-1" />
    </>
  ),
  key: (
    <>
      <circle cx="8" cy="15" r="4.2" />
      <path d="m11 12 8.4-8.4M16.4 6.6l2.4 2.4M14 9l2 2" />
    </>
  ),
  arrowRight: <path d="M5 12h14M13.4 6.4 19 12l-5.6 5.6" />,
  arrowLeft: <path d="M19 12H5M10.6 6.4 5 12l5.6 5.6" />,
  user: (
    <>
      <circle cx="12" cy="8.4" r="3.8" />
      <path d="M5.6 20.4a6.4 6.4 0 0 1 12.8 0" />
    </>
  ),
  copy: (
    <>
      <rect x="8.4" y="8.4" width="11.6" height="11.6" rx="1.4" />
      <path d="M15.6 8.4V5.4A1.4 1.4 0 0 0 14.2 4H5.4A1.4 1.4 0 0 0 4 5.4v8.8a1.4 1.4 0 0 0 1.4 1.4h3" />
    </>
  ),
  shield: (
    <>
      <path d="M12 2.8 19.6 5.8v5.6c0 4.6-3.2 8.4-7.6 9.8-4.4-1.4-7.6-5.2-7.6-9.8V5.8z" />
      <path d="m8.8 12 2.2 2.2 4.2-4.4" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.8" />
      <path d="M12 7.4V12l3 2" />
    </>
  ),
  refresh: <path d="M19.6 12a7.6 7.6 0 1 1-2.2-5.4M19.6 4.4v4.4h-4.4" />,
  star: <path d="m12 3.6 2.6 5.3 5.8.8-4.2 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z" />,
  console: (
    <>
      <rect x="3" y="4.4" width="18" height="15.2" rx="1.6" />
      <path d="M3 8.6h18M7 12.6l2.4 2-2.4 2M12 16.6h4.4" />
    </>
  ),
  auto: (
    <>
      <circle cx="12" cy="12" r="8.8" />
      <path d="M12 3.2v17.6" />
    </>
  ),
} as const;
